import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { asyncScheduler, Subscription } from 'rxjs';
import { AppState } from '../../core';
import { Building } from '../../core/models';
import { BuildingDoc, BuildingService } from '../../core/services';
import { FesBaseComponent } from '../../shared/components/fes-base.component';
import {TestbedRxdbService} from "../../core/services/testbed-rxdb";
import { Market } from '../../core/models/market';
import { MarketService } from '../../core/services/market.service';

@Component({
  selector: 'app-rxdb-buildings-edit',
  templateUrl: './rxdb-buildings-edit.component.html',
  styleUrls: ['./rxdb-buildings-edit.component.scss']
})
export class RxdbBuildingsEditComponent extends FesBaseComponent implements OnInit {
  
  replicationStateSubscription: Subscription;
  
  @Input() set building( building : BuildingDoc ) {
    if ( building ) {
      this._building = building
      this.tmpBuilding = { ...building.toJSON() }
    } 
  }
  rxMarkets : Market[] = []
  _building : BuildingDoc
  tmpBuilding : Building
  
  errorMsg: string;
  bProcessing: boolean;
  
  get building() { return this._building }

  constructor(appState : AppState,
    protected buildingService: BuildingService,
    protected rxdbService: TestbedRxdbService,
    protected marketsService: MarketService,
    protected editModal : BsModalRef) {
    super(appState);
  }

  ngOnInit(): void {
    this.loadMarkets();
  }
  
  ngOnDestroy(): void {
    this.replicationStateSubscription?.unsubscribe()
  }

  async loadMarkets() {
    this.errorMsg = ""
    this.rxMarkets = []

    try {
      this.replicationStateSubscription?.unsubscribe()
      this.replicationStateSubscription = this.marketsService.getMarkets().subscribe((data:Market[])=>{
        this.rxMarkets=data;
      });
    } catch ( error ) {
      this.errorMsg = this.marketsService.extractErrorMsg(error)
    }
  }
  
  onCancel() {
    this.editModal.hide()
  }
  
  async onSave() {
    this.errorMsg = ''
    this.bProcessing = true;
    try {
      if ( this.tmpBuilding.id ) {
        await this.buildingService.update(this.tmpBuilding).toPromise()
      }
      this.editModal.hide()
    } catch ( error ) {
      this.errorMsg = this.buildingService.extractErrorMsg(error)
      this.buildingService.publishError(error,this)
    } finally {
      asyncScheduler.schedule( () => this.buildingService.syncNow() )
      this.bProcessing = false
    }
  }
}